import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.SET_DAYS](state, days) {
    state.retrospectiveDay = days
    storage.session.setItem(types.SESSION_DAYS, days)
  },
  [types.SET_VIEW](state, view) {
    state.view = view
    storage.session.setItem(types.SESSION_VIEW, view)
  },
  [types.SET_STATUS](state, status) {
    state.status = status
    storage.session.setItem(types.SESSION_STATUS, status)
  },
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.SESSION_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.SESSION_PAGE_SIZE, pageSize)
  },
  [types.SET_START_DATE](state, date) {
    state.startDate = date
    storage.session.setItem(types.SESSION_START_DATE, date)
  },
  [types.SET_END_DATE](state, date) {
    state.endDate = date
    storage.session.setItem(types.SESSION_END_DATE, date)
  },
  [types.COMPANY_NUMBER_SCANS_OVERALL](state, data) {
    let i
    let _data = []
    if (data.items === null) {
      _data = [10, 20, 30]
    } else {
      for (i = 0; i < data.items.length; i++) {
        _data[i] = data.items[i].numberScans
      }
    }
    state.dataCompanyNumberScansOverall = _data
    storage.session.setItem(types.SESSION_COMPANY_NUMBER_SCANS_OVERALL, JSON.stringify(_data))
    state.widgetLoaded.push({
      name: 'CompanyNumberScansOverall'
    })
  },
  [types.COMPANY_NUMBER_SCANS](state, data) {
    let _data = []
    if (data.counts === 0) {
      _data.push({
        value: 0
      })
    } else {
      _data.push({
        value: data.counts
      })
    }
    state.dataCompanyNumberScans = _data
    storage.session.setItem(types.SESSION_COMPANY_NUMBER_SCANS, JSON.stringify(_data))
    state.widgetLoaded.push({
      name: 'CompanyNumberScans'
    })
  },
  [types.COMPANY_AVG_SCAN_TIMES](state, data) {
    let _data = []
    if (data.items === null) {
      _data.push({
        value: 0
      })
    } else {
      _data.push({
        value: data.items[0].avgScanTime
      })
    }
    state.dataCompanyAvgScanTimes = _data
    storage.session.setItem(types.SESSION_COMPANY_AVG_SCAN_TIMES, JSON.stringify(_data))
    state.widgetLoaded.push({
      name: 'CompanyAvgScanTimes'
    })
  },
  [types.PERSONAL_YESTERDAY_SCANS](state, data) {
    let _data = []
    if (data.count === 0) {
      _data.push({
        value: 0
      })
    } else {
      for (let datum of data.items) {
        _data.push({
          name: datum.masterTechnician,
          value: datum.count
        })
      }
    }
    state.dataPersonalYesterdayScans = _data
    storage.session.setItem(types.SESSION_PERSONAL_YESTERDAY_SCANS, JSON.stringify(_data))
    state.widgetLoaded.push({
      name: 'PersonalYesterdayScans'
    })
  },
  [types.PERSONAL_AVG_SCANS](state, data) {
    let _data = []
    if (data.items === null) {
      _data.push({
        value: 0
      })
    } else {
      let avg = 0
      if (data.items.length > 0) {
        let total = 0
        for (let item of data.items) {
          total += item.numberScans
        }
        avg = Math.round(total / data.items.length)
      }
      _data.push({
        value: avg
      })
    }
    state.dataPersonalAvgScans = _data
    storage.session.setItem(types.SESSION_PERSONAL_AVG_SCANS, JSON.stringify(_data))
    state.widgetLoaded.push({
      name: 'PersonalAvgScans'
    })
  },
  [types.PERSONAL_AVG_SCAN_TIMES](state, data) {
    let _data = []
    if (data.items === null) {
      _data.push({
        value: 0
      })
    } else {
      _data.push({
        value: data.items[0].avgScanTime
      })
    }
    state.dataPersonalAvgScanTimes = _data
    storage.session.setItem(types.SESSION_PERSONAL_AVG_SCAN_TIMES, JSON.stringify(_data))
    state.widgetLoaded.push({
      name: 'PersonalAvgScanTimes'
    })
  },
  [types.PERSONAL_AVG_CYCLE_TIMES](state, data) {
    let _data = []
    if (data.items === null) {
      _data.push({
        value: 0
      })
    } else {
      let total = 0
      let avg = 0
      for (let item of data.items) {
        total += parseFloat(item.avgCycleTime)
      }
      if (data.items.length > 0) {
        avg = total / data.items.length
      }
      _data.push({
        value: avg
      })
    }
    state.dataPersonalAvgCycleTimes = _data
    storage.session.setItem(types.SESSION_PERSONAL_AVG_CYCLE_TIMES, JSON.stringify(_data))
    state.widgetLoaded.push({
      name: 'PersonalAvgCycleTimes'
    })
  },
  [types.SET_TECH](state, tech) {
    state.tech = null
    if (tech !== undefined && tech !== null) {
      state.tech = tech
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/mutations.js